export const SwimProfileSelector = ({ SwimProfileStore: { uploadProfiles } }) =>
  uploadProfiles;

export const SwimSelectedProgramSelector = ({
  SwimProfileStore: { selectedProgramDetails }
}) => selectedProgramDetails;
